"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * API V1
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.AnalyticsTotalsToJSON = exports.AnalyticsTotalsFromJSONTyped = exports.AnalyticsTotalsFromJSON = exports.instanceOfAnalyticsTotals = void 0;
var runtime_1 = require("../runtime");
/**
 * Check if a given object implements the AnalyticsTotals interface.
 */
function instanceOfAnalyticsTotals(value) {
    var isInstance = true;
    return isInstance;
}
exports.instanceOfAnalyticsTotals = instanceOfAnalyticsTotals;
function AnalyticsTotalsFromJSON(json) {
    return AnalyticsTotalsFromJSONTyped(json, false);
}
exports.AnalyticsTotalsFromJSON = AnalyticsTotalsFromJSON;
function AnalyticsTotalsFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'salesTotal': !(0, runtime_1.exists)(json, 'salesTotal') ? undefined : json['salesTotal'],
        'salesQty': !(0, runtime_1.exists)(json, 'salesQty') ? undefined : json['salesQty'],
        'voucherTotal': !(0, runtime_1.exists)(json, 'voucherTotal') ? undefined : json['voucherTotal'],
        'voucherQty': !(0, runtime_1.exists)(json, 'voucherQty') ? undefined : json['voucherQty'],
        'refundTotal': !(0, runtime_1.exists)(json, 'refundTotal') ? undefined : json['refundTotal'],
        'itemsTotal': !(0, runtime_1.exists)(json, 'itemsTotal') ? undefined : json['itemsTotal'],
        'netSales': !(0, runtime_1.exists)(json, 'netSales') ? undefined : json['netSales'],
    };
}
exports.AnalyticsTotalsFromJSONTyped = AnalyticsTotalsFromJSONTyped;
function AnalyticsTotalsToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'salesTotal': value.salesTotal,
        'salesQty': value.salesQty,
        'voucherTotal': value.voucherTotal,
        'voucherQty': value.voucherQty,
        'refundTotal': value.refundTotal,
        'itemsTotal': value.itemsTotal,
        'netSales': value.netSales,
    };
}
exports.AnalyticsTotalsToJSON = AnalyticsTotalsToJSON;
